import React from 'react';

interface ExposureCardProps {
    broadcastName: string;
    children?: React.ReactNode;
    style?: React.CSSProperties;
    frameUrl?: string;
    verbalMentionsExample?: {
        mention?: string;
        videoUrl?: string;
    };
}

const ExposureCard = ({
    style,
    broadcastName,
    frameUrl,
    verbalMentionsExample,
    children = null,
}: ExposureCardProps) => {
    const containerStyle = {
        maxWidth: '60%',
        backgroundColor: 'white',
        borderRadius: '8px',
        border: '1px solid #A3BDC7',
        padding: '12px',
        display: 'flex',
        flexDirection: 'column' as const,
        gap: '20px',
        ...style,
    };

    const imageStyle = {
        width: '100%',
        height: 'auto',
    };

    const headerStyle = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    };

    const titleStyle = {
        fontSize: '16px',
        fontWeight: '400' as const,
        color: '#333',
    };

    const iconStyle = {
        fontSize: 20,
        color: '#5F6D7E',
        marginLeft: '10px',
    };

    const videoLinkStyle = {
        fontSize: '14px',
        color: '#009FDF',
        textDecoration: 'none',
        textAlign: 'center' as const,
        whiteSpace: 'nowrap' as const,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    };

    const getIconClass = () => {
        return verbalMentionsExample ? 'fas fa-megaphone' : 'fas fa-tv-retro';
    };

    return (
        <div style={containerStyle}>
            {frameUrl && !verbalMentionsExample && (
                <img src={frameUrl} style={imageStyle} alt="Broadcast frame" />
            )}

            <div style={headerStyle}>
                <span style={titleStyle}>{broadcastName}</span>
                <i className={getIconClass()} style={iconStyle} />
            </div>

            {verbalMentionsExample?.videoUrl && (
                <div style={videoLinkStyle}>
                    <a
                        href={verbalMentionsExample.videoUrl}
                        rel="noreferrer"
                        target="_blank"
                    >
                        <i className="fas fa-link" /> Video Clip URL
                    </a>
                </div>
            )}

            {children}
        </div>
    );
};

export default ExposureCard;
